import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { PublicStudioListVM } from "@shared-kernel/application/ports/public/public-repository";

export const retrievePublicStudios = createAsyncThunk<PublicStudioListVM[], void, { extra: Partial<Dependencies> }>(
  "shared/studios/retrieve-public",
  async (_, { extra: { publicRepository } }) => {
    return publicRepository!.getPublicStudios();
  },
);
